export default __webpack_public_path__ + "static/media/cabourg7.6f98d1c3.jpg";